export default __webpack_public_path__ + "static/acmw_logo-c7faec311924767c24a72c6230baf04c.png";